<div class="unblock-request-container p-3">

  <!-- Subtitle -->
  <p class="modal-subtitle ps-1" *ngIf="!permissions.includes('Approve')   && this.requestsVisible" >
    You are making an unblock request for below customer. The request will be sent L2 for approval
  </p>
  <p class="modal-subtitle ps-1" *ngIf="permissions.includes('Approve')  && this.requestsVisible">
    You are reviewing an unblock request for below customer.
  </p>


  <h6 class="ps-1 mt-3">Customer Details</h6>

  <div class="card custom-light-border border-2 rounded-3 shadow-sm">
    <div class="card-body p-3">

      <!-- Row 1 -->
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="form-label fw-medium text-light-gray ps-1">Full Name</label>
          <p class="mb-0 ps-1">{{ customer.fullName }}</p>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-medium text-light-gray ps-1">Contact Number</label>
          <p class="mb-0 ps-1">{{ customer.contactNumber }}</p>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-medium text-light-gray ps-1">Screening Provider</label>
          <p class="mb-0 ps-1">{{ customer.screeningProvider }}</p>
        </div>
      </div>

      <!-- Row 2 -->
      <div class="row mb-3">
        <!-- <div class="col-md-4">
          <label class="form-label fw-medium text-light-gray ps-1">Blocked By</label>
          <p class="mb-0 ps-1">{{ customer.blockedBy }}</p>
        </div> -->
        <div class="col-md-8">
          <label class="form-label fw-medium text-light-gray ps-1">Blocked On</label>
          <p class="mb-0 ps-1">{{ customer.blockedOn }}</p>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-medium text-light-gray ps-1">Screening On</label>
          <p class="mb-0 ps-1">{{ customer.screeningOn }}</p>
        </div>
      </div>

      <!-- Row 3: Reason/Status -->
      <div class="row mb-3 align-items-start">
        <div class="col-md-8">
          <label class="form-label fw-medium text-light-gray ps-1">Reason/Remarks</label>
          <p class="mb-0 ps-1">{{ customer.remark }}</p>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-medium text-light-gray ps-1">Status After Unblock</label>
          <p class="mb-0 fw-bold ps-1" [ngClass]="{'text-success': customer.statusAfterUnblock === 'ACTIVE'}">
            {{ customer.statusAfterUnblock }}
          </p>
        </div>
      </div>

      <!-- Level 1 Comments & Initiated By -->
      <div *ngIf="permissions.includes('Approve') && customer.initiatorRemarks && customer.initiatorID" class="row mb-3 align-items-start">
  <div class="col-md-8">
    <label class="form-label fw-medium text-light-gray ps-1">Level 1 Comments</label>
    <p class="mb-0 ps-1">{{ customer.initiatorRemarks }}</p>
  </div>
  <div class="col-md-4">
    <label class="form-label fw-medium text-light-gray ps-1">Initiated By</label>
    <p class="mb-0 fw-bold ps-1">{{ customer.initiatorID }}</p>
  </div>
</div>


    </div>
  </div>

  
  <div class="modal-body ps-1" >
    <div class="mb-3" *ngIf="permissions.includes('Approve')" >
      <label    for="comment" class="form-label ps-1">
        Approval Comment For Unblock Request <span class="text-danger">*</span>
      </label>
      <textarea class="border-orange w-100" id="comment" rows="3"
      [(ngModel)]="customer.approverRemarks "
    [disabled]=" (customer.status === 'APPROVED' || customer.status === 'REJECTED')"
      ></textarea>
    </div>
    

        <div class="mb-3"    *ngIf="!permissions.includes('Approve')">
      <label  for="comment" class="form-label ps-1">
        Reason For Unblock Request <span class="text-danger">*</span>
      </label>
      <textarea class="border-orange w-100" id="comment" rows="3"
      [(ngModel)]="customer.initaitorRemarks"
      [disabled]=" permissions.includes('Approve') && (customer.status === 'APPROVED' || customer.status === 'REJECTED')"
      ></textarea>
    </div>

    <!-- File Upload -->
    <div class="mb-3 d-flex align-items-center gap-2 ps-1">
      <button class="btn bg-danger-custom" (click)="fileInput.click()">Upload Document</button>
      <input type="file" #fileInput (change)="onFileSelected($event)" hidden />
      <button *ngIf="customer.initiatorDocument && permissions.includes('Approve')"
        class="btn bg-danger-custom" (click)="downloadInitiatorDocs()" title="Download Uploaded Document">
        <i class="fa fa-download"></i>
      </button>
    </div>

    <p *ngIf="selectedFile" class="text-success mt-2 ps-1">Selected file: {{ selectedFile.name }}</p>
    <p *ngIf="fileErrorMessage" class="text-danger mt-1 ps-1">{{ fileErrorMessage }}</p>
  </div>

  <!-- Footer Buttons -->
  <div class="modal-footer">
    <button type="button" class="btn bg-danger-custom" *ngIf="!permissions.includes('Approve')" (click)="submitRequest()">Submit</button>
    <button type="button" class="btn btn-secondary" *ngIf="!permissions.includes('Approve')" (click)="onCancel()">Cancel</button>
     <!-- Approve button for checker -->
      
<!-- Approve button -->
<span *ngIf="permissions.includes('Approve') "
      [ngbTooltip]="customer.status !== 'PENDING' ? 'Request already processed' : ''"
      container="body">
  <button type="button" 
          class="btn bg-danger-custom" 
          [disabled]="customer.status !== 'PENDING'"
          (click)="approveRequest()">
    Approve
  </button>
</span>

<span *ngIf="permissions.includes('Approve')" 
      [ngbTooltip]="customer.status !== 'PENDING' ? 'Request already processed' : ''"
      container="body">
  <!-- Reject button for checker -->
  <button type="button" 
          class="btn bg-danger-custom" 
          [disabled]="customer.status !== 'PENDING'"
          (click)="rejectRequest()">
    Reject
  </button>  
</span>


</div>



</div>
